import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstallPromptComponent } from './install-prompt.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from '@app/_services/translation.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@app/_services/api.service';

@NgModule({
	imports: [
		CommonModule,
		IonicModule,
		FormsModule,
		TranslateModule.forChild({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [ApiService]
			}
		})
	],
	declarations: [InstallPromptComponent],
	exports: [InstallPromptComponent]
})
export class InstallPromptModule {}
